export enum VrsCallCommentsLogMessages {
  CALL_COMPLETE_INITIATE = 'Call complete initiate',
  VRS_REPORT_SENT_SUCCESS = 'VRS report sent success',
}
